import { Route } from "react-router";
import * as React from "react";
import * as WbContext from "../stores/context";
import * as DocContext from "../../documents/stores/context";
import WorkbenchPage from "../screens/WorkbenchPage";

const workbenchRoute = () => {
    return (
        <>
            <Route
                path={"workbench"}
                element={
                    <WbContext.WorkbenchStoreProvider>
                        <DocContext.DocumentsStoreProvider>
                            <WorkbenchPage />
                        </DocContext.DocumentsStoreProvider>
                    </WbContext.WorkbenchStoreProvider>
                }
            />
        </>
    );
};

export default workbenchRoute;
